import './FaqEmbed.scss';

interface FaqEmbedProps {
  embedCode: string;
}

const FaqEmbed = ({ embedCode }: FaqEmbedProps) => {
  const extractSrc = (html: string): string | null => {
    const srcMatch: RegExpMatchArray = html.match(/src=["']([^"']+)["']/);
    return srcMatch ? srcMatch[1] : null;
  };

  const extractTitle = (html: string): string => {
    const titleMatch: RegExpMatchArray = html.match(/title=["']([^"']+)["']/);
    return titleMatch ? titleMatch[1] : 'Embedded video';
  };

  const src: string = extractSrc(embedCode);
  const title: string = extractTitle(embedCode);

  if (!src) {
    return null;
  }

  return (
    <div className="faq-embed">
      <iframe
        src={src}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
};

export default FaqEmbed;